import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import SweetAlert from "sweetalert2-react";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import EditarVip from "../Componentes/EditarPost";
import ReactPlayer from "react-player";
import fire from "../config/Fire";

const styles = {
  card: {
    Width: 300,
    height: 320
  },
  media: {
    height: 150,
    width: 300
  }
};

class CartaVIP extends Component {
  constructor(props) {
    super(props);

    this.titulo = props.title;
    this.contenido = props.contenido;
    this.tipo = props.tipo;
    this.link = props.link;
  }
  componentDidMount() {
    var contenido = this.contenido;
    var titulo = this.titulo;
    if (contenido.length > 50)
      this.setState({ contenido: contenido.substring(0, 80) + "..." });
    else this.setState({ contenido: contenido });
    if (titulo.length > 22)
      this.setState({ titulo: titulo.substring(0, 22) + "..." });
    else this.setState({ titulo: titulo });
  }
  handleClose = () => {
    this.setState({ show: true });
  };

  state = {
    show: false
  };
  //Abre el dialogo para confirmar la eliminación
  confirmarEliminacion() {
    this.setState({ show: true, confirmacion: "Eliminar" });
  }
  eliminar(titulo, link, tipo) {
    this.setState({ show: false });
    if (tipo === "imagen") {
      this.setState({ nombreimg: null });

      fire.auth().onAuthStateChanged(user => {
        fire
          .database()
          .ref()
          .child("Posts")
          .orderByChild("titulo")
          .equalTo(titulo)
          .on("child_added", snapshot => {
            this.setState({ nombreimg: snapshot.val().nombreimg });
          });
        if (user) {
          const storageRefImg = fire
            .storage()
            .ref(`/Posts/${titulo}/${this.state.nombreimg}`);
          storageRefImg
            .delete()
            .then(function() {
              fire
                .database()
                .ref()
                .child("Posts")
                .orderByChild("titulo")
                .equalTo(titulo)
                .on("child_added", snapshot => {
                  fire
                    .database()
                    .ref()
                    .child("Posts")
                    .child(snapshot.key)
                    .remove();
                });
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      });
    } else {
      fire
        .database()
        .ref()
        .child("Posts")
        .orderByChild("titulo")
        .equalTo(titulo)
        .on("child_added", snapshot => {
          fire
            .database()
            .ref()
            .child("Posts")
            .child(snapshot.key)
            .remove();
        });
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card className={classes.card}>
          <CardActionArea>
            {this.tipo === "imagen" ? (
              <CardMedia
                className={classes.media}
                image={this.link}
                title="Contemplative Reptile"
              />
            ) : (
              <ReactPlayer width="300" height="300" url={this.link} />
            )}

            <CardContent>
              <Typography gutterBottom style={{ fontSize: "17px" }}>
                {this.state.titulo}
              </Typography>
              <Typography component="p">{this.state.contenido}</Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button
              size="small"
              color="primary"
              onClick={() => this.confirmarEliminacion()}
            >
              ELIMINAR
            </Button>
            <EditarVip
              titulo={this.titulo}
              contenido={this.contenido}
              tipo={this.tipo}
            />
          </CardActions>

          <SweetAlert
            show={this.state.show}
            title="¿Estás seguro?"
            text="No podrás revertir los cambios"
            type="warning"
            showCancelButton="true"
            confirmButtonColor="#3085d6"
            cancelButtonColor="#d33"
            cancelButtonText="Cancelar"
            confirmButtonText={this.state.confirmacion}
            onConfirm={() => this.eliminar(this.titulo, this.link, this.tipo)}
          />
        </Card>
      </div>
    );
  }
}

CartaVIP.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CartaVIP);
